import AppInfoComponentResourceModel from '../../generated/types/model/resource/AppInfoComponentResourceModel';

export default class AppInfoComponentResourceViewModel extends AppInfoComponentResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
